import { render } from "./PlaceholderGrid.vue?vue&type=template&id=4c05a0f0&scoped=true"
import script from "./PlaceholderGrid.vue?vue&type=script&lang=js"
export * from "./PlaceholderGrid.vue?vue&type=script&lang=js"

import "./PlaceholderGrid.vue?vue&type=style&index=0&id=4c05a0f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c05a0f0"]])

export default __exports__